import { API_BASE_URL } from "../config/api";

const INSURANCE_BLOG_URL = `${API_BASE_URL}/insurance/blog`;

const parseResponse = async (response) => {
  const contentType = response.headers.get("content-type") || "";
  if (contentType.includes("application/json")) return response.json();

  const text = await response.text();
  if (!text || contentType.includes("text/html") || /<!doctype\s+html|<html[\s>]/i.test(text)) {
    return {};
  }
  return { message: text };
};

const findErrorMessage = (value) => {
  if (typeof value === "string" && value.trim()) return value.trim();
  if (Array.isArray(value)) {
    for (const item of value) {
      const message = findErrorMessage(item);
      if (message) return message;
    }
    return "";
  }
  if (value && typeof value === "object") {
    for (const key of ["detail", "message", "non_field_errors"]) {
      const message = findErrorMessage(value[key]);
      if (message) return message;
    }
    for (const nested of Object.values(value)) {
      const message = findErrorMessage(nested);
      if (message) return message;
    }
  }
  return "";
};

const request = async (url, options, fallbackMessage) => {
  const response = await fetch(url, options);
  const data = await parseResponse(response);

  if (!response.ok) {
    const error = new Error(findErrorMessage(data) || fallbackMessage);
    error.status = response.status;
    error.code = data.code;
    error.data = data;
    throw error;
  }

  return data;
};

const buildQueryString = (params = {}) => {
  const query = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, String(value));
    }
  });
  const serialized = query.toString();
  return serialized ? `?${serialized}` : "";
};

export const getInsuranceBlogPosts = (params = {}, signal) =>
  request(
    `${INSURANCE_BLOG_URL}/posts/${buildQueryString(params)}`,
    {
      method: "GET",
      headers: { Accept: "application/json" },
      signal,
    },
    "We could not load the latest insurance insights."
  );

export const getInsuranceBlogPost = (slug, signal) =>
  request(
    `${INSURANCE_BLOG_URL}/posts/${encodeURIComponent(slug)}/`,
    {
      method: "GET",
      headers: { Accept: "application/json" },
      signal,
    },
    "We could not load this insurance insight."
  );

export const recordInsuranceBlogPostView = (slug, visitorId) => {
  const body = visitorId ? { visitor_id: visitorId } : {};
  return request(
    `${INSURANCE_BLOG_URL}/posts/${encodeURIComponent(slug)}/views/`,
    {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    },
    "We could not record this article view."
  );
};

export const getInsuranceBlogCategories = (signal) =>
  request(
    `${INSURANCE_BLOG_URL}/categories/`,
    {
      method: "GET",
      headers: { Accept: "application/json" },
      signal,
    },
    "We could not load insurance blog categories."
  );

const blogApi = {
  getInsuranceBlogPosts,
  getInsuranceBlogPost,
  recordInsuranceBlogPostView,
  getInsuranceBlogCategories,
};

export default blogApi;
